<template>
  <div>
    <div class="page_top">
      <div class="sechout">
        <div class="sech-left" @click="back()">
          <van-icon name="arrow-left" color="#ffffff" size="20" />
        </div>
        <div class="sech-right" @click="toRecord">缴费记录</div>
      </div>
      <div class="page_top_title">
        <span class="page_top_title_txt">物业缴费</span>
      </div>
    </div>
    <div class="content">
      <van-row type="flex" justify="center">
        <van-col span="22">
          <div>
            <div class="pay_title">缴费金额</div>
            <div class="pay_content" @click="fill">
              <span class="money_icon">￥</span>
              <div class="pay_amount">{{amount}}</div>
            </div>
            <div class="pay_integral" v-if="amount != ''">
              <span class="pay_integral_left">可获得积分：</span>
              <span class="pay_integral_right">{{amount}}</span>
            </div>
            <div class="content_form">
              <div class="content_form_item">
                <div class="content_form_item_key">
                  住址信息
                </div>
                <div class="content_form_item_val">
                  阳光城上府1区1幢1单元1011
                </div>
              </div>
              <div class="content_form_item">
                <div class="content_form_item_key">
                  联系方式
                </div>
                <div class="content_form_item_val">
                  18238932232
                </div>
              </div>
              <div class="content_form_item">
                <div class="content_form_item_key">
                  真实姓名
                </div>
                <div class="content_form_item_val">
                  天才瑞普利
                </div>
              </div>
              <div class="content_form_item">
                <div class="content_form_item_key">
                  物业电话
                </div>
                <div class="content_form_item_val">
                  6659845
                </div>
              </div>
            </div>
            <div class="agreement" @click="is_check = !is_check">
              <img class="agreement_check" v-if="is_check" src="../../../../assets/house/property/property_choose.png"
                alt="">
              <img class="agreement_check" v-else src="../../../../assets/house/property/property_unchoose.png" alt="">
              <span class="agreement_181F2C">我已阅读并同意</span>
              <span class="agreement_26C165">《缴纳物业费须知》</span>
            </div>
            <div class="btn" @click="result">提交</div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        amount: '',
        is_check: false,
      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      fill() {
        this.amount = '666666'
      },
      result() {
        this.$router.push('/house/property/paySuccess')
      },
      toRecord() {
        this.$router.push('/house/property/propertyPayCostRecord')
      }
    },
  }
</script>

<style lang="less" scoped>
  .page_top {
    height: 162px;
    background: #26C165;
  }

  .sechout {
    height: 44px;
    padding: 15px 15px 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .page_top_title {
    padding-left: 20px;
    margin-top: 14px;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
  }

  .content {
    background: #fff;
    padding-top: 20px;
    transform: translateY(-12px);
    border-radius: 12px 12px 0px 0px;
  }

  .pay_title {
    font-size: 12px;
    font-weight: 400;
    color: #222325;
    line-height: 17px;
    margin-bottom: 12px;
  }

  .pay_content {
    height: 45px;
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    margin-bottom: 12px;
    border-bottom: 1px solid #222325;
  }

  .pay_amount {
    font-size: 32px;
    font-weight: 600;
    color: #222325;
    margin-left: 8px;
  }

  .money_icon {
    font-size: 16px;
    font-weight: 400;
    color: #222325;
  }

  .pay_integral {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .pay_integral_left {
    font-size: 12px;
    font-weight: 400;
    color: #B3B9BF;
  }

  .pay_integral_right {
    font-size: 12px;
    font-weight: 500;
    color: #26C165;
  }

  .content_form {
    height: 144px;
    background: #F8F8F8;
    border-radius: 6px;
    padding: 16px;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .content_form_item {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
    color: #6D7177;
  }

  .content_form_item_key {
    width: 68px;
  }

  .agreement {
    height: 44px;
    display: flex;
    align-items: center;
  }

  .agreement_check {
    width: 16px;
    margin-right: 8px;
  }

  .agreement_181F2C,
  .agreement_26C165 {
    font-size: 12px;
    font-weight: 400;
    color: #181F2C;
  }

  .agreement_26C165 {
    color: #26C165;
  }

  .btn {
    height: 48px;
    text-align: center;
    line-height: 48px;
    background-color: #26C165;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
  }
</style>